<prlw-action-button-ui
  [label]="label"
  [pending]="pending$ | async"
  (eventClick)="handleClick()"
></prlw-action-button-ui>
